<template>
  <div>
    <Modal :styles="{ top: '20px' }" :value="true" title="User Modal" :closable="false" class="license-add-modal"
      :mask-closable="false">
      <div slot="header" class="d-flex justify-content-between align-items-center">
        <h5 v-if="realLicense">{{ $t('global.edit_user') }}</h5>
        <h5 v-else>{{ $t('global.add') }}</h5>
        <Button @click="close()" type="text" icon="md-close" class="modal-close-btn"></Button>
      </div>
      <Spin v-if="modalLoading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <Form v-else class="add-form-modal" ref="addFormModal" :label-width="130" :model="formValidate"
        :rules="ruleValidate">

        <FormItem :label="$t('user.table.name')" prop="firstName" class="position-relative">
          <Input v-model="formValidate.firstName" name="first_name" placeholder="text..." type="text" />
          <Icon v-if="realLicense && realLicense.firstName && formValidate.firstName !== realLicense.firstName"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('user.table.surname')" prop="secondName">
          <Input v-model="formValidate.secondName" name="last_name" placeholder="text..." type="text" />
          <Icon v-if="realLicense && realLicense.secondName && formValidate.secondName !== realLicense.secondName"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('user.form.geburtsdatum')" prop="birthday">
          <DatePicker v-model="formValidate.birthday" @on-change="fixDatesByTimezone" name="datetime" placeholder="Selecteaza data" type="date"
            format="dd.MM.yyyy"></DatePicker>
          <Icon
            v-if="realLicense && realLicense.birthday && $moment(formValidate.birthday).format('DD.MM.YYYY') !== $moment(realLicense.birthday).format('DD.MM.YYYY')"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('club.table.sex')" prop="sex">
          <Select v-model="formValidate.sex" filterable :placeholder="$t('global.kiezen')" name="gender">
            <Option value="1">{{ $t('global.male') }}</Option>
            <Option value="2">{{ $t('global.female') }}</Option>
          </Select>
          <Icon
            v-if="realLicense && realLicense.hasOwnProperty('sex') && parseInt(formValidate.sex) !== parseInt(realLicense.sex)"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('club.club')" prop="club">
          <Select :disabled="user && user.role.includes('manager')" @on-change="onChangeClub"
            v-model="formValidate.clubId" filterable clearable :placeholder="$t('global.kiezen')" name="club">
            <Option v-for="club in clubs" :key="club._id" :value="club._id">{{ club.name }}</Option>
          </Select>
          <Icon
            v-if="realLicense && realLicense.hasOwnProperty('clubId') && realLicense.clubId && formValidate.clubId !== realLicense.clubId._id"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('club.aditional_club')" prop="additionalClubs">
          <Select v-model="formValidate.extraClubs" filterable clearable multiple :placeholder="$t('global.kiezen')"
            name="club">
            <Option v-for="club in extraClubs" :key="club._id" :value="club._id">{{ club.name }}</Option>
          </Select>
          <Icon
            v-if="realLicense && realLicense.hasOwnProperty('extraClubs') && Array.isArray(realLicense.extraClubs) && formValidate.extraClubs.toString() !== realLicense.extraClubs.map((extra) => extra._id).toString()"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('club.form.town')" prop="town">
          <Select v-model="formValidate.town" name="town" placeholder="Enter town..." filterable
            :placeholder="$t('global.kiezen')">
            <Option v-for="item in cities" :value="item" :key="item">{{ item }}</Option>
          </Select>
          <Icon v-if="realLicense && realLicense.hasOwnProperty('town') && formValidate.town !== realLicense.town"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('user.form.nationality')" prop="nationality">
          <Select v-model="formValidate.nationality" name="nationality" placeholder="Enter nationality..." filterable
            :placeholder="$t('global.kiezen')">
            <Option v-for="item in nationalities" :value="item" :key="item">{{ item }}</Option>
          </Select>
          <Icon
            v-if="realLicense && realLicense.hasOwnProperty('nationality') && formValidate.nationality !== realLicense.nationality"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('global.category')" prop="category">
          <Select v-model="formValidate.categoryId" name="category">
            <Option v-for="category  in categories" :key="category._id" :value="category._id">{{ category.name }}
            </Option>
          </Select>
          <Icon
            v-if="(realLicense && realLicense.hasOwnProperty('categoryId') && !realLicense.categoryId) || (realLicense && realLicense.categoryId && formValidate.categoryId !== realLicense.categoryId._id)"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('club.table.photo')" prop="photo" class="transport-tech-pass">
          <Card>
            <div slot="title">
              <Upload ref="uploadphoto" type="drag" multiple :show-upload-list="false"
                :before-upload="() => progressFile('uploadphoto')" :on-success="(file) => handleSuccess(file, 'photo')"
                :format="['jpg', 'jpeg', 'png']" :max-size="12048" :on-format-error="(file) => handleFormatError(file, 2)"
                :on-remove="(res, file) => handleRemove(res, 'photo')" :action="api_domain + 'file/upload'">
                <div style="padding: 10px 0; width: 100%">
                  <Icon type="ios-cloud-upload" size="37" style="color: #3399ff"></Icon>
                  <p>Click or drag files here to upload</p>
                </div>
                <Spin class="hidden" fix></Spin>
              </Upload>
            </div>
            <div v-if="formValidate.photo.length > 0" class="upload-file-list-block">
              <a v-for="(att, key) in formValidate.photo" :href="api_domain + att" class="mr-1 upload-file-list"
                target="_blank">
                <i class="attachment bx bxs-file" style="font-size: 37px"></i>
                <i class='bx bxs-trash' style="font-size: 15px; color: red" data-key="photo" :id="att"
                  @click="handleRemoveUploadList"></i>
              </a>
            </div>
          </Card>
          <Icon v-if="realLicense && realLicense.photo && formValidate.photo.toString() !== realLicense.photo.toString()"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>

        <FormItem :label="$t('club.table.contract')" prop="membership" class="transport-tech-pass">
          <Card>
            <div slot="title">
              <Upload ref="uploadmembership" type="drag" multiple :show-upload-list="false"
                :before-upload="() => progressFile('uploadmembership')"
                :on-success="(file) => handleSuccess(file, 'membership')"
                :format="['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx']" :max-size="12048"
                :on-format-error="(file) => handleFormatError(file, 1)"
                :on-remove="(res, file) => handleRemove(res, 'membership')" :action="api_domain + 'file/upload'">
                <div style="padding: 10px 0; width: 100%">
                  <Icon type="ios-cloud-upload" size="37" style="color: #3399ff"></Icon>
                  <p>Click or drag files here to upload</p>
                </div>
                <Spin class="hidden" fix></Spin>
              </Upload>
            </div>
            <div v-if="formValidate.membership.length > 0" class="upload-file-list-block">
              <a v-for="(att, key) in formValidate.membership" :href="api_domain + att" class="mr-1 upload-file-list"
                target="_blank">
                <i class="attachment bx bxs-file" style="font-size: 37px"></i>
                <i class='bx bxs-trash' style="font-size: 15px; color: red" data-key="membership" :id="att"
                  @click="handleRemoveUploadList"></i>
              </a>
            </div>
          </Card>
          <Icon
            v-if="realLicense && realLicense.membership && formValidate.membership.toString() !== realLicense.membership.toString()"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>
        <FormItem :label="$t('club.table.passport')" prop="passportId" class="transport-tech-pass">
          <Card>
            <div slot="title">
              <Upload ref="uploadpassportId" type="drag" multiple :show-upload-list="false"
                :before-upload="() => progressFile('uploadpassportId')"
                :on-success="(file) => handleSuccess(file, 'passportId')" :format="['jpg', 'jpeg', 'png', 'pdf']"
                :max-size="12048" :on-format-error="(file) => handleFormatError(file)"
                :on-remove="(res, file) => handleRemove(res, 'passportId')" :action="api_domain + 'file/upload'">
                <div style="padding: 10px 0; width: 100%">
                  <Icon type="ios-cloud-upload" size="37" style="color: #3399ff"></Icon>
                  <p>Click or drag files here to upload</p>
                </div>
                <Spin class="hidden" fix></Spin>
              </Upload>
            </div>
            <div v-if="formValidate.passportId.length > 0" class="upload-file-list-block">
              <a v-for="(att, key) in formValidate.passportId" :href="api_domain + att" class="mr-1 upload-file-list"
                target="_blank">
                <i class="attachment bx bxs-file" style="font-size: 37px"></i>
                <i class='bx bxs-trash' style="font-size: 15px; color: red" data-key="passportId" :id="att"
                  @click="handleRemoveUploadList"></i>
              </a>
            </div>
          </Card>
          <Icon
            v-if="realLicense && realLicense.passportId && formValidate.passportId.toString() !== realLicense.passportId.toString()"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>


        <FormItem :label="$t('club.table.control')" prop="medical" class="transport-tech-pass">
          <Card>
            <div slot="title">
              <Upload ref="uploadmedical" type="drag" multiple :show-upload-list="false"
                :before-upload="() => progressFile('uploadmedical')"
                :on-success="(file) => handleSuccess(file, 'medical')" :format="['jpg', 'jpeg', 'png', 'pdf']"
                :max-size="12048" :on-format-error="(file) => handleFormatError(file)"
                :on-remove="(res, file) => handleRemove(res, 'medical')" :action="api_domain + 'file/upload'">
                <div style="padding: 10px 0; width: 100%">
                  <Icon type="ios-cloud-upload" size="37" style="color: #3399ff"></Icon>
                  <p>Click or drag files here to upload</p>
                </div>
                <Spin class="hidden" fix></Spin>
              </Upload>
            </div>
            <div v-if="formValidate.medical.length > 0" class="upload-file-list-block">
              <a v-for="(att, key) in formValidate.medical" :href="api_domain + att" class="mr-1 upload-file-list"
                target="_blank" :id="att">
                <i class="attachment bx bxs-file" style="font-size: 37px"></i>
                <i class='bx bxs-trash' style="font-size: 15px; color: red" data-key="medical" :id="att"
                  @click="handleRemoveUploadList"></i>
              </a>
            </div>
          </Card>
          <Icon
            v-if="realLicense && realLicense.medical && formValidate.medical.toString() !== realLicense.medical.toString()"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>

        <FormItem :label="$t('club.table.control_medical_date')" prop="medical_Date">
          <Select v-model="formValidate.medical_Date">
            <Option v-for="year in Array.from({ length: 3 }, (_, i) => (new Date().getFullYear() + 1) - i)"
              :key="'year_' + year" :value="year.toString()">{{ year }}</Option>
          </Select>
          <Icon
            v-if="realLicense && realLicense.hasOwnProperty('medical_Date') && realLicense && parseInt(formValidate.medical_Date) !== parseInt(realLicense.medical_Date)"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>


        <FormItem :label="$t('club.table.attachment')" prop="attachments" class="transport-tech-pass">
          <Card>
            <div slot="title">
              <Upload ref="uploadattachments" type="drag" multiple :show-upload-list="false"
                :before-upload="() => progressFile('uploadattachments')"
                :on-success="(file) => handleSuccess(file, 'attachments')" :format="['jpg', 'jpeg', 'png', 'pdf']"
                :max-size="12048" :on-format-error="(file) => handleFormatError(file)"
                :on-remove="(res, file) => handleRemove(res, 'attachments')" :action="api_domain + 'file/upload'">
                <div style="padding: 10px 0; width: 100%">
                  <Icon type="ios-cloud-upload" size="37" style="color: #3399ff"></Icon>
                  <p>Click or drag files here to upload</p>
                </div>
                <Spin class="hidden" fix></Spin>
              </Upload>
            </div>
            <div v-if="formValidate.attachments.length > 0" class="upload-file-list-block">
              <a v-for="(att, key) in formValidate.attachments" :href="api_domain + att" class="mr-1 upload-file-list"
                target="_blank" :id="att">
                <i class="attachment bx bxs-file" style="font-size: 37px"></i>
                <i class='bx bxs-trash' style="font-size: 15px; color: red" data-key="attachments" :id="att"
                  @click="handleRemoveUploadList"></i>
              </a>
            </div>
          </Card>
          <Icon
            v-if="realLicense && realLicense.attachments && formValidate.attachments.toString() !== realLicense.attachments.toString()"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>

        <FormItem :label="$t('competition.notes')" prop="notes">
          <Input v-model="formValidate.notes" placeholder="text..." type="textarea" />
          <Icon v-if="realLicense && realLicense.hasOwnProperty('notes') && formValidate.notes !== realLicense.notes"
            type="md-alert" color="red" class="alert-expire-date icon-position" />
        </FormItem>

      </Form>
      <div slot="footer" class="text-center">
        <ButtonGroup class="modal-footer-btn">
          <Button v-if="realLicense && enableFor(['super', 'admin', 'license_admin'])" @click="active()"
            :type="realLicense.status === 1 ? 'primary' : 'warning'"><b>{{ realLicense.status
              === 1 ? $t('club.license.activate')
              : $t('club.license.deactivate') }}</b>
          </Button>
          <Button @click="handleSubmit('addFormModal')" :loading="loading" type="success"><b>{{ $t('global.save')
          }}</b></Button>
          <Button v-if="enableFor(['super', 'admin', 'license_admin']) && tempLicense" @click="approve()"
            :loading="loading" type="info"><b>{{ $t('global.approve')
            }}</b></Button>
        </ButtonGroup>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: [
    'license',
    'loading'
  ],
  data() {
    return {
      serverError: '',
      deleteFileIndex: null,
      clubs: [],
      extraClubs: [],
      user: null,
      tempLicense: null,
      modalLoading: this.loading,
      changes: false,
      categories: [],
      realLicense: null,
      checker: false,
      nationalities: ['Moldovean', 'Roman', 'Ucrainean', 'Gagauz', 'Rus', 'Bulgar', 'Romani', 'Evrei', 'Polonez'],
      cities: ['Bălți', 'Biruința', 'Briceni', 'Costești', 'Cupcini', 'Dondușeni', 'Drochia', 'Edineț', 'Fălești', 'Florești', 'Frunză', 'Ghindești', 'Glodeni', 'Lipcani', 'Mărculești', 'Ocnița', 'Otaci', 'Rîșcani', 'Sîngerei', 'Soroca', 'Anenii Noi', 'Bucovăț', 'Căinari', 'Călărași', 'Căușeni', 'Cornești', 'Criuleni', 'Hîncești', 'Ialoveni', 'Nisporeni', 'Orhei', 'Rezina', 'Strășeni', 'Șoldănești', 'Ștefan Vodă', 'Telenești', 'Tighina (Bender)', 'Ungheni', 'Chișinău', 'Codru', 'Cricova', 'Durlești', 'Sîngera', 'Vadul lui Vodă', 'Vatra', 'Basarabeasca', 'Cantemir', 'Cahul', 'Cimișlia', 'Iargara', 'Leova', 'Taraclia', 'Tvardița', 'Camenca', 'Crasnoe', 'Dnestrovsc', 'Dubăsari', 'Grigoriopol', 'Rîbnița', 'Maiac', 'Slobozia', 'Tiraspol', 'Tiraspolul Nou', 'Ceadîr-Lunga', 'Comrat', 'Vulcănești'],
      formValidate: {
        firstName: '',
        secondName: '',
        birthday: '',
        sex: '',
        clubId: null,
        extraClubs: [],
        nationality: '',
        town: '',
        categoryId: null,
        photo: [],
        membership: [],
        passportId: [],
        medical: [],
        medical_Date: new Date().getFullYear().toString(),
        attachments: [],
        notes: ''
      },
      ruleValidate: {
        firstName: [
          { required: true, message: 'The input cannot be empty', trigger: 'blur' }
        ],
        secondName: [
          { required: true, message: 'The input cannot be empty', trigger: 'blur' }
        ],
        birthday: [
          { required: true, type: 'date', message: 'The input cannot be empty', trigger: 'change' }
        ],
        sex: [
          { required: true, message: 'The input cannot be empty', trigger: 'blur' }
        ],
        // categoryId: [
        //   { required: this.checker, message: 'The input cannot be empty' }
        // ],
        // photo: [
        //   { required: this.checker, type: 'array', min: 1, max: 5, message: 'The input cannot be empty or more that 5' }
        // ],
        // membership: [
        //   { required: this.checker, type: 'array', min: 1, max: 5, message: 'The input cannot be empty or more that 5' }
        // ],
        // passportId: [
        //   { required: this.checker, type: 'array', min: 1, max: 5, message: 'The input cannot be empty or more that 5' }
        // ],
        // medical: [
        //   { required: this.checker, type: 'array', min: 1, max: 5, message: 'The input cannot be empty or more that 5' }
        // ],
        // medical_Date: [
        //   { required: this.checker, message: 'The input cannot be empty' }
        // ]
      }
    }
  },
  watch: {
    formValidate: {
      deep: true,
      handler(n, o) {
        this.changes = true
        let fields = Object.keys(this.ruleValidate)
        if (this.realLicense && n) {
          for (let i = 0; i < fields.length; i++) {
            const element = fields[i];
            let category = this.realLicense.newcategoryId ? this.realLicense.newcategoryId._id : this.realLicense.categoryId._id
            let bday = this.realLicense.newbirthday ? this.realLicense.newbirthday : this.realLicense.birthday
            if (n.categoryId.toString() !== category.toString()) {
              console.log(n.categoryId, category._id);
              this.deactivate = true
              break
            } else if (n.birthday.getTime() !== new Date(bday).getTime()) {
              console.log(n.birthday, new Date(bday));
              this.deactivate = true
              break
            }
            else if (element !== 'categoryId' && element !== 'birthday' && n[element].toString() !== this.realLicense[element].toString()) {
              console.log(n[element], this.realLicense[element]);
              this.deactivate = true
              break
            } else {
              this.deactivate = false
            }
          }
        } else {
          this.deactivate = true
        }

      }
    },
    deactivate(n) {
      console.log(n);
    }
  },
  methods: {
    onChangeClub(val) {
      this.extraClubs = [...this.clubs.filter((club) => club._id !== val)]
    },
    progressFile(key) {
      if (this.$refs[key]) {
        console.log(key, this.$refs[key].$children[1].$el.classList.contains('hidden'))
        if (this.$refs[key].$children[1].$el.classList.contains('hidden')) {
          this.$refs[key].$children[1].$el.classList.toggle('hidden')
        }
      }

      return true;

    },
    checkIfSportsman() {
      console.log(this.realLicense);

      if (this.realLicense) {
        let category = this.realLicense.newcategoryId ? this.realLicense.newcategoryId.name : this.realLicense.categoryId.name
        this.checker = category === 'SPORTSMAN'
      } else if (this.enableFor(['manager'])) {
        this.checker = true
      }
      console.log(this.checker);
    },
    getCurrentUser() {
      const user = localStorage.getItem('user')
      this.user = JSON.parse(user)
    },
    enableFor(arr) {
      if (this.user && !this.user.role) return false;
      return this.user && arr.includes(this.user.role[0])
    },
    fixDatesByTimezone(e) {
      const [day, month, year] = e.split(".")
      let date
      if(day && month && year)
        date = new Date(Date.UTC(year, month - 1, day, 0, 0,0)); 
      else
        date = null
      this.formValidate.birthday = date;
      console.log(this.formValidate.birthday);
    },
    async getTempLicense() {
      try {
        const res = await this.$http.get('/temp-license/get/' + this.realLicense._id)
        if (res.data)
          this.tempLicense = res.data
        else
          this.tempLicense = null
      } catch (error) {
        console.log(error)
      }
    },
    async approve() {
      let fields = Object.keys(this.realLicense)
      let toSend = {}
      for (let i = 0; i < fields.length; i++) {
        const element = fields[i];
        if (this.realLicense.hasOwnProperty(element) && typeof this.tempLicense[element] !== 'object' && this.realLicense[element] !== this.tempLicense[element]) {
          toSend[element] = this.tempLicense[element]
        }
        else if (this.realLicense.hasOwnProperty(element) && typeof this.tempLicense[element] === 'object' && !this.tempLicense[element]) {
          toSend[element] = this.tempLicense[element]
        }
        else if (this.realLicense.hasOwnProperty(element) && typeof this.tempLicense[element] === 'object' && !this.tempLicense[element].hasOwnProperty('length') && (this.realLicense[element] !== this.tempLicense[element] || this.realLicense[element]._id !== this.tempLicense[element]._id)) {
          toSend[element] = this.tempLicense[element]._id
        }
        else if (this.realLicense.hasOwnProperty(element) && typeof this.tempLicense[element] === 'object' && this.tempLicense[element].hasOwnProperty('length') && this.realLicense[element].toString() !== this.tempLicense[element].toString()) {
          toSend[element] = this.tempLicense[element]
        }
      }
      try {
        const res = await this.$http.post('/license/approve', { licenseData: { _id: this.realLicense._id.toString(), ...toSend } })
        if (res.status === 201) {
          try {
            const temp = await this.$http.post('/temp-license/delete', { _id: this.realLicense._id.toString() })
            if (temp.status === 201) {
              console.log(temp.data)
              setTimeout(() => { this.changes = false }, 0)
            }
          } catch (error) {
            console.log(error)
          }
          this.modalLoading = false
          const data = await this.$http.get('/license/get/' + res.data._id)
          this.realLicense = data.data
          this.formValidate = { ...data.data }
          this.formValidate.birthday = new Date(this.formValidate.birthday)
          this.formValidate.medical_Date = this.formValidate.medical_Date.toString()
          this.formValidate.clubId = this.formValidate.clubId ? this.formValidate.clubId._id : null
          this.formValidate.categoryId = this.formValidate.categoryId && this.formValidate.categoryId._id
          this.formValidate.sex = this.formValidate.sex.toString()
          this.$emit('updateList', 0)
          this.$Message.success('Success!')
          setTimeout(() => { this.changes = false }, 0)
        }
      } catch (e) {
        console.log(e)
        this.modalLoading = false
        console.log(e.response)
        this.serverError = e.response.data.codes[0]
      }
    },
    async managerEdit() {
      if (this.realLicense)
        this.getTempLicense()
      this.serverError = ''
      let type = 'addNew'
      if (this.tempLicense) type = 'editNew'
      try {
        this.modalLoading = true
        let response
        if (this.realLicense) {
          response = await this.$http.post('/temp-license/' + type, {
            licenseData: { ...this.formValidate, _id: this.realLicense._id, status: this.deactivate === true ? 1 : this.realLicense.status }
          })
          if (this.deactivate === true) {
            console.log(this.deactivate);
            await this.$http.post('/license/editNew', {
              licenseData: { _id: this.realLicense._id, status: 1 }
            })
          }
        }
        else {
          const emptyLicense = await this.$http.post('/license/addNew', { licenseData: { firstName: " ", secondName: " ", birthday: new Date(), clubId: this.user.clubId, sex: null, nationality: '', medical_Date: null, town: '', notes: '' } })
          console.log(emptyLicense)
          response = await this.$http.post('/temp-license/' + type, {
            licenseData: { ...this.formValidate, _id: emptyLicense.data._id }
          })
        }
        if (response.status === 201) {
          this.modalLoading = false
          // if (!this.realLicense) this.$refs['addFormModal'].resetFields()
          if (!this.tempLicense) this.clearForm()
          this.$emit('updateList', 0)
          this.$Message.success('Success!')
          this.$emit('close', 0)
        }
      } catch (e) {
        console.log(e)
        this.modalLoading = false
        console.log(e.response)
        this.serverError = e.response.data.codes[0]
      }
    }
    ,
    async active() {
      console.log(this.realLicense.status)
      this.modalLoading = true
      if (this.enableFor(['super', 'admin', 'license_admin']) && this.tempLicense) {
        await this.approve()
      }
      console.log(this.realLicense.status)
      let response = await this.$http.post('/license/editActive', {
        licenseData: {
          _id: this.realLicense._id.toString(),
          status: this.realLicense.status === 1 ? 2 : 1
          // status: (this.realLicense.status === 0 || this.realLicense.status === 1) ? 2 : 0
        }
      })
      if (response.status === 201) {
        // this.$refs['addFormModal'].resetFields()
        this.$emit('updateList', 0)
        this.modalLoading = false
        this.$Message.success('Success!')
        setTimeout(() => {
          this.$emit('close')
        }, 700)
      }
      this.modalLoading = false
    },
    close(_value) {
      if (this.changes === true) {
        this.$dialog
          .confirm(
            this.$t('global.nonSaveConfirm'),
            {
              okText: this.$t("global.yes"),
              cancelText: this.$t("global.no"),
              html: true,
              customClass: "mahnung-confirm",
            }
          ).then(async (_dialog) => {
            this.$emit('close', 0)
          }).catch((error) => {
            console.log(error);
          });
      } else { this.$emit('close', 0) }
    },
    clearForm() {
      this.serverError = ''
      this.modalLoading = false
      this.deleteFileIndex = null
      this.formValidate.firstName = ''
      this.formValidate.secondName = ''
      this.formValidate.birthday = ''
      this.formValidate.sex = ''
      this.formValidate.clubId = this.user.clubId ? this.user.clubId._id : null
      this.formValidate.extraClubs = []
      this.formValidate.nationality = ''
      this.formValidate.categoryId = null
      this.formValidate.town = ''
      this.formValidate.photo = []
      this.formValidate.membership = []
      this.formValidate.passportId = []
      this.formValidate.medical = []
      this.formValidate.medical_Date = new Date().getFullYear().toString()
      this.formValidate.attachments = []
      this.formValidate.notes = ''
    },
    handleReset(name) {
      this.$refs[name].resetFields()
    },
    handleFormatError(file, status) {
      let formats = 'jpg, png or pdf.'
      if (status === 1) formats = 'jpg, png, pdf or doc.'
      else if (status === 2) formats = 'jpg or png'
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc:
          'File format of ' +
          file.name +
          ' is incorrect, please select ' + formats
      })
    },
    handleSuccess(res, key) {
      this.formValidate[key].push(res.path)

      if (this.$refs['upload' + key]) {
        if (!this.$refs['upload' + key].$children[1].$el.classList.contains('hidden')) {
          this.$refs['upload' + key].$children[1].$el.classList.toggle('hidden');
        }
      }
    },
    handleRemove(res, key) {
      this.formValidate[key].splice(res, 1);
    },
    handleRemoveUploadList(res, key) {
      console.log(res, key)
      res.preventDefault();
      this.formValidate[res.target.dataset.key].splice(res, 1);
      // this.uploadList.splice(res, 1);
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          if (this.user.role.includes('manager'))
            await this.managerEdit()
          else
            await this.submitForm()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    async submitForm() {
      this.serverError = ''
      let type = 'addNew'
      if (this.realLicense) type = 'editNew'
      try {
        this.modalLoading = true
        let response = await this.$http.post((this.tempLicense ? '/temp-license/' : '/license/') + type, {
          licenseData: this.formValidate
        })
        if (response.status === 201) {
          this.modalLoading = false
          // if (!this.realLicense) this.$refs['addFormModal'].resetFields()
          if (!this.realLicense) this.clearForm()
          this.$emit('updateList', 0)
          this.$Message.success('Success!')
          this.changes = false
          this.deactivate = false
          this.$emit('close', 0)
        }
      } catch (e) {
        console.log(e)
        this.modalLoading = false
        console.log(e.response)
        this.serverError = e.response.data.codes[0]
      }
    },
    async getClubs() {
      this.modalLoading = true
      let response = await this.$http.post('/club/list', {})
      let list = response.data
      this.modalLoading = false
      this.clubs = [...list]
      if (this.realLicense && this.realLicense.clubId)
        this.extraClubs = [...list.filter((club) => club._id !== this.realLicense.clubId._id)]
      else if (this.user.role.includes('manager'))
        this.extraClubs = [...list.filter((club) => club._id !== this.user.clubId._id)]
      else
        this.extraClubs = [...list]
    },
    async getCategories() {
      this.modalLoading = true
      let response = await this.$http.post('/license/category/list', {})
      let list = response.data
      this.modalLoading = false
      this.categories = [...list]
      if (this.realLicense == null) {
        this.formValidate.categoryId = this.categories[0]._id
        setTimeout(() => { this.changes = false; this.deactivate = false }, 0)
      }
      if (this.user.role.includes('manager'))
        this.categories = this.categories.filter((cat) => cat.name === 'SPORTSMAN')
    }
  },
  async mounted() {
    this.getCurrentUser()
    if (this.license) {
      this.realLicense = {}
      let fields = Object.keys(this.license)
      for (let i = 0; i < fields.length; i++) {
        const element = fields[i];
        if (element.includes('Search') || element.includes('display')) {
          console.log("wrong field");
        } else {
          this.realLicense[element] = this.license[element]
        }
      }
      // this.realLicense = this.license
    }
    this.checkIfSportsman()
    this.ruleValidate.categoryId = [
      { required: this.checker, message: 'The input cannot be empty' }
    ]
    this.ruleValidate.photo = [
      { required: this.checker, type: 'array', min: 1, max: 5, message: 'The input cannot be empty or more than 5' }
    ]
    // this.ruleValidate.membership = [
    //   { required: this.checker, type: 'array', min: 1, max: 5, message: 'The input cannot be empty or more than 5' }
    // ]
    this.ruleValidate.passportId = [
      { required: this.checker, type: 'array', min: 1, max: 5, message: 'The input cannot be empty or more than 5' }
    ]
    this.ruleValidate.medical = [
      { required: this.checker, type: 'array', min: 1, max: 5, message: 'The input cannot be empty or more than 5' }
    ]
    this.ruleValidate.medical_Date = [
      { required: this.checker, message: 'The input cannot be empty' }
    ]
    await this.getClubs()
    await this.getCategories();

    if (this.realLicense !== null) {
      this.modalLoading = true
      let val
      await this.getTempLicense()
      if (this.tempLicense !== null)
        val = JSON.parse(JSON.stringify(this.tempLicense))
      else
        val = JSON.parse(JSON.stringify(this.realLicense))
      let obj = {
        ...this.formValidate,
        ...val
      }
      this.formValidate = { ...obj }
      this.formValidate.birthday = new Date(this.formValidate.birthday)
      this.formValidate.medical_Date = this.formValidate.medical_Date.toString()
      this.formValidate.clubId = this.formValidate.clubId ? this.formValidate.clubId._id : null
      this.formValidate.categoryId = this.formValidate.categoryId && this.formValidate.categoryId._id
      this.formValidate.sex = this.formValidate.sex.toString()
      if (this.license.extraClubs && Array.isArray(this.license.extraClubs) && this.formValidate.extraClubs) {
        let extras = []
        this.license.extraClubs.forEach(item => extras.push(item._id))
        this.formValidate.extraClubs = [...extras]
      }
      setTimeout(() => { this.changes = false; this.deactivate = false }, 100)
      this.modalLoading = false
    }
    if (this.user.role.includes('manager')) {
      this.formValidate.clubId = this.user.clubId ? this.user.clubId._id : null
      setTimeout(() => { this.changes = false; this.deactivate = false }, 100)
    }
  }
}

</script>
<style scoped>
.hidden.ivu-spin.ivu-spin-default.ivu-spin-fix {
  display: none;
}

.add-form-modal :global(.ivu-form-item) {
  margin-bottom: 10px;
}

.license-add-modal :global(.ivu-form-item-label) {
  padding: 5px 12px 5px 0;
  margin-bottom: 0;
}

.license-add-modal :global(.ivu-card-head p) {
  font-size: 13px;
  color: #495057;
}

.upload-file-btn :global(.ivu-icon) {
  color: #2DB7F7;
  font-weight: bold;
}

.modal-footer-btn button {
  min-width: 150px;
}

.modal-close-btn {
  padding: 0 5px;
  font-size: 20px;
}

.upload-file-btn :global(.ivu-icon) {
  color: #2DB7F7;
  font-weight: bold;
}

.icon-position {
  position: absolute;
  top: 50%;
  right: 20px;
  font-size: 16px;
  transform: translateY(-50%);
}

.license-add-modal :global(.ivu-select-arrow) {
  right: 5px !important;
}

.transport-tech-pass :global(.ivu-form-item-content .ivu-upload) {
  width: 100%;
}

.upload-file-list {
  position: relative;
  display: inline-block;
}

.upload-file-list .bxs-trash {
  position: absolute;
  top: -5px;
  right: -2px;
  display: none;
  opacity: .8;
}

.upload-file-list .bxs-trash:hover {
  opacity: 1;
}

.upload-file-list:hover .bxs-trash {
  display: inline-block;
}

.transport-tech-pass :global(.ivu-card-head) {
  border-bottom: none;
}

.transport-tech-pass :global(.ivu-card-body) {
  padding: 0;
}

div :global(.ivu-form-item-error-tip) {
  z-index: 100 !important;
  position: relative;
}

.upload-file-list-block {
  padding: 10px 16px;
  border-top: 1px solid #e8eaec;
}

.transport-tech-pass :global(.ivu-upload-list .ivu-upload-list-file) {
  display: flex;
  align-items: center;
}

.transport-tech-pass :global(.ivu-upload-list .ivu-upload-list-file>span) {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 244px;
  position: relative;
  padding-left: 17px;
  display: block;
}

.transport-tech-pass :global(.ivu-upload-list .ivu-upload-list-file>span>i) {
  position: absolute;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/license/LicenseAddModal.vue